import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, type InjectionToken } from '@angular/core';

import { Observable, throwError } from 'rxjs';

import { provide } from '@core/common-legacy';

@Injectable()
export class EmptyPathInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/null') || req.url.includes('/undefined')) {
      console.warn('Detected null or undefined in the request path:', req.url);
      return throwError(
        () => new Error(`Invalid request URL – contains "null" or "undefined": ${req.url}`),
      );
    }
    return next.handle(req);
  }
}

export const provideEmptyPathInterceptor = provide(
  <InjectionToken<HttpInterceptor>>HTTP_INTERCEPTORS,
  { useClass: EmptyPathInterceptor, multi: true },
);
